import { jsx as l } from "react/jsx-runtime";
import { c as r } from "./tw-cn-mXgPecoF.mjs";
import { c as p } from "./variance-DhhqoHkK.mjs";
const g = p(["flex flex-col gap-8 rounded-12 justify-center"], {
  variants: {
    theme: {
      warning: "bg-fill-warning-weak",
      info: "bg-fill-neutral-weak"
    },
    align: {
      left: "items-start",
      center: "items-center",
      right: "items-end"
    },
    type: {
      single: "px-16 py-4 min-h-40 pc:px-20 pc:min-h-48",
      multiple: "py-12 px-16 pc:py-16 pc:px-20 gap-12"
    }
  },
  defaultVariants: {
    theme: "warning",
    type: "single",
    align: "left"
  }
}), m = ({
  children: e,
  theme: t = "warning",
  type: a = "single",
  align: n = "left",
  className: s
}) => {
  const i = g({ theme: t, type: a, align: n });
  return /* @__PURE__ */ l("div", { className: r(i, s), children: e });
};
m.displayName = "NDS.MessageBox";
export {
  m as M
};
